/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './createAccount.defs'
export { main as default } from './createAccount.defs'
